import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <div>
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <section className="footervideobg" id="section_1">
          <div className="footer-section-overlay"></div>
          <div className="video-wrap video-background">
            <video
              autoPlay
              loop
              muted
              playsInline
              className="custom-video"
              poster=""
            >
              <source src="assets/video/footerbg.mp4" type="video/mp4" />
            </video>
          </div>
        </section>

        <div className="content container">
          <div className="row footer_logobar d-flex g-5 align-items-center">
            {/* Image Section */}
            <div className="col-lg-6 position-relative text-center mb-3">
              <img
                className="m-0"
                src="assets/img/logo/ktig_white2.png"
                alt="ktig-logo-2"
              />
            </div>

            {/* Subscription Form Section */}
            <div className="col-lg-6 align-items-end m-auto align-items-end">
              <div className="w-100 subscriptbt align-items-end position-relative">
                <input
                  type="email"
                  className="form-control rounded-pill w-100 py-3 ps-4 pe-5"
                  placeholder="Enter your email"
                />
                <button
                  className="btn btn-secondary rounded-pill position-absolute top-0 end-0 py-2 mt-2 me-2"
                  style={{
                    whiteSpace: "nowrap",
                    background: "Orange",
                    borderRadius: "12px",
                  }}
                >
                  Subscribe
                </button>
              </div>
            </div>
          </div>

          <div className="row col-lg-12 m-auto g-5">
            <div className="col-md-6 col-lg-6 col-xl-2">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-true-white font-m mb-2">About Us</h4>
                <Link to="/about-ktig" className="font-s">
                  <i className="fas fa-angle-right me-2"></i> Why Choose KTIG
                </Link>

                <Link to="/terms-conditions" className="font-s">
                  <i className="fas fa-angle-right me-2"></i> Terms & Conditions
                </Link>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-2">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-true-white font-m mb-2">careers</h4>
                <Link to="/current-openings" className="font-s">
                  <i className="fas fa-angle-right me-2"></i>Current Openings
                </Link>
                <Link to="/upload-cv" className="font-s">
                  <i className="fas fa-angle-right me-2"></i>Upload CV
                </Link>
                {/* <Link to="" className="buttons footerlinkbtn">
                  Admin Login
                </Link> */}
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-2">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-true-white font-m mb-2">KTIG Groups</h4>
                <Link
                  to="/kovai-tech-nidhi-limited"
                  target="_blank"
                  className="font-s"
                >
                  <i className="fas fa-angle-right me-2"></i> Kovai Tech Nidhi
                  Limited
                </Link>
                <Link
                  to="/kovai-tech-member-chamber"
                  target="_blank"
                  className="font-s"
                >
                  <i className="fas fa-angle-right me-2"></i> Kovai Tech Member
                  Chamber
                </Link>
                <Link to="/bnr-cogniitec" target="_blank" className="font-s">
                  <i className="fas fa-angle-right me-2"></i> BNR Cogniitec Pvt
                  Ltd
                </Link>
                <Link to="/br-academy" target="_blank" className="font-s">
                  <i className="fas fa-angle-right me-2"></i> BR Academy Pvt Ltd
                </Link>
                <Link to="/skillorea" target="_blank" className="font-s">
                  <i className="fas fa-angle-right me-2"></i>Skillorea Pvt Ltd
                </Link>
                <Link to="/paval-soft" target="_blank" className="font-s">
                  <i className="fas fa-angle-right me-2"></i> Paval Soft Pvt Ltd
                </Link>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 col-xl-2">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-true-white font-m mb-2">Innovest</h4>
                <Link to="/finance-partner" className="font-s">
                  <i className="fas fa-angle-right me-2"></i> Finance Partner
                </Link>
                <Link to="/joint-venture-partner" className="font-s">
                  <i className="fas fa-angle-right me-2"></i> Joint Venture
                  Partner
                </Link>
                <Link to="/consulting-partner" className="font-s">
                  <i className="fas fa-angle-right me-2"></i> Consulting Partner
                </Link>
                <Link to="/sponsorship-partner" className="font-s">
                  <i className="fas fa-angle-right me-2"></i> Sponsorship
                  Partner
                </Link>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 col-xl-2">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-true-white font-m mb-2">Contact Info</h4>
                {/* <a href="ktig_services" className="font-s"><i className="fas fa-angle-right me-2"></i> Meet KTIG</a> */}
                <Link to="/corporate-office" className="font-s">
                  <i className="fas fa-angle-right me-2"></i> Corporate Office
                </Link>
                <Link to="/business-hours" className="font-s">
                  <i className="fas fa-angle-right me-2"></i> Business Hours
                </Link>
                <Link to="/privacy-policies" className="font-s">
                  <i className="fas fa-angle-right me-2"></i> Privacy Policies
                </Link>
                <Link to="/user-delete-request" className="font-s">
                  <i className="fas fa-angle-right me-2"></i> User Delete
                  Request
                </Link>
              </div>
            </div>
          </div>

          <div className="row g-5 mb-5 d-block mt-10 align-items-center">
            <div className="col-lg-12 footer-social-icons">
              <div className="d-flex align-items-center justify-content-center justify-content-lg-center">
                <a
                  className="btn btn-secondary btn-md-square rounded-circle me-2"
                  href="https://www.facebook.com/ktigcbe"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a
                  className="btn btn-secondary btn-md-square rounded-circle me-2"
                  href="https://x.com/ktigcbe"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-twitter"></i>
                </a>
                <a
                  className="btn btn-secondary btn-md-square rounded-circle me-2"
                  href="https://www.instagram.com/ktigcbe_/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  className="btn btn-secondary btn-md-square rounded-circle me-2"
                  href="https://www.linkedin.com/company/kovai-tech-india-group-ktig/?viewAsMember=true"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a
                  className="btn btn-secondary btn-md-square rounded-circle me-2"
                  href="https://www.youtube.com/@Ktigcbe"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-youtube"></i>
                </a>
                <a
                  className="btn btn-secondary btn-md-square rounded-circle me-2"
                  href="https://www.pinterest.com/ktigcbe/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-pinterest"></i>
                </a>
                <a
                  className="btn btn-secondary btn-md-square rounded-circle me-2"
                  href="https://www.tumblr.com/blog/ktigcbe"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-tumblr"></i>
                </a>
                <a
                  className="btn btn-secondary btn-md-square rounded-circle"
                  href="https://whatsapp.com/channel/0029VazHB8TFcow4tnamgs2x"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-whatsapp"></i>
                </a>
              </div>
            </div>
            <div className="col-md-6 d-block m-auto text-center mt-3">
              <span className="text-copyright">
                <a href="/" className="text-copyright">
                  Kovai Tech India Group{" "}
                  <i className="fas fa-copyright text-light"></i>
                </a>{" "}
                All right reserved.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
